import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal } from "antd";
import { Form, Radio, message, notification, InputNumber } from "antd";
import { Col, Row } from "react-bootstrap";
import TextInput from "../../../common/UITextInput/TextInput";
import UiButton from "../../../common/UiButton/UiButton";
import UISectionHeading from "../../../common/UiDrawerHeading/UiDrawerHeading";

import UiDropDown from "../../../common/UiDropDown/UiDropDown";
import { connect } from "react-redux";
import {
  getAddLeadMasterList,
  getEditLeadDetails,
  getBranchLocationByArea,
  getBranchLocationByPincode,
  getPincodeOnSearch,
  getSideBarBranch,
  saveAddLeadDetails,
  searchCollegeDetails,
  searchCourseDetail,
  searchPartnerNameDetail,
  searchUniversityDetails,
  getRelationshipDetails,
  deleteCoApp,
  getCourseTypeName,
} from "../../../redux/AddLead/action";
import useForm from "../../../common/hooks/useForm";

import useSession from "../../CustomLogout/useSession";
import CustomLogout from "../../CustomLogout/CustomLogout";

import AsyncSelect from "react-select/async";
import { useSelector, useDispatch } from "react-redux";

const EditLead = (props) => {
  const [form] = Form.useForm();
  const handleSessionExpired = useSession();

  const dispatch = useDispatch();
  const qualificationType = useSelector(
    (state) =>
      state?.dashboardReducer?.dashboardDetails?.data?.dto?.qualifiedPartner
  );

  const { setPartnerRefresh, LogoutFlag, setDrawerOpen, drawerOpen, row } =
    props;
  const FormItem = Form.Item;
  const history = useNavigate();
  let pincodeArray = [];

  const onClose = () => {
    form.resetFields();
    setDrawerOpen(false);
  };

  const { setFieldsValue } = form;
  const { state, onChangeTextHandler, setState } = useForm();
  const [reloptions, setRelOptions] = useState([]);
  const [cityId, setCityId] = useState("");
  const [cityName, setCityName] = useState("");
  const [stateId, setStateId] = useState("");
  const [stateName, setStateName] = useState("");
  const [inputValue, setValue] = useState("");
  const [valError, setValError] = useState(false);
  const [disablecoapp, setdisablecoapp] = useState(false);
  const [addLeadMasterData, setAddLeadMasterData] = useState();
  const [showDrowDown, setShowDrowDown] = useState(false);
  const [showSchool, setShowSchool] = useState(false);
  const [showCours, setshowCours] = useState(false);
  const [dataPartnerBranchPincode, setDataPartnerBranchPincode] = useState();
  const [partnerBranchPincodeValue, setPartnerBranchPincodeValue] = useState();
  const [partnerBranchPincodeId, setPartnerBranchPincodeId] = useState();
  const [deleteId, setDeleteID] = useState();
  const [deleteModal, setDeteteModal] = useState(false);
  const [reletion, setRelation] = useState("");
  const [docvalue, setDocvalue] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [courseType, setCourseType] = useState([]);
  const [loanType, setLoanType] = useState([]);

  const [stemRadio, setStemRadio] = useState(false);

  const [cour, setCour] = useState("");
  const [uni, setUni] = useState("");
  const [inst, setInst] = useState("");

  const location = useLocation();
  const leadId = location?.state?.leadId;

  const [contactRadio, setContactRadio] = useState(false);
  const [valueRadio, setValueRadio] = useState(291);

  const partnerFirmId = props?.auth?.checkLogin?.partnerFirmId;

  const initialCoApplicantData = {
    incomeTobeConsideredFlag: true,
    required: true,
    applicantType: "CO_APPLICANT",
    emailAddress: "",
    firstName: "",
    fullname: "",
    lastName: "",
    middleName: "",
    dateOfBirth: 0, // Assuming dateOfBirth is a number field
    mobileNo: "",
    salutation: "",
    salutationId: "",
    relationship: "",
    relationshipId: "",
  };

  // const initialCoApplicants = Array.from({ length: 2 }, (_, index) => ({
  //   id: index + 1,
  //   ...initialCoApplicantData,
  //   incomeTobeConsideredFlag: index === 0 ? true : false, // Set to true for the first co-applicant, false for others
  // }));

  const [coApplicants, setCoApplicants] = useState([]);
  const [relationData, setRelationData] = useState([]); // Assuming you have some data for the dropdown

  const onChangeAdmission = (e) => {
    setValueRadio(e.target.value);
    setValError(false);
    setshowCours(false);
    setShowSchool(false);
    setShowDrowDown(false);

    form.setFieldsValue({
      university: "",
      universityText: "",
      instituteText: "",
      institute: "",
      courseText: "",
      course: "",
      country: "",
    });
    setState({
      ...state,
      universityText: "",
      instituteText: "",
      courseText: "",
      university: "",
      institute: "",
      course: "",
      country: "",
    });

    setUni("");
    setInst("");
    setCour("");
    form.resetFields("university");
    form.resetFields("universityText");
    form.resetFields("institute");
    form.resetFields("instituteText");
    form.resetFields("courseText");
    form.resetFields("course");
  };

  const handleStemChanges = (e) => {
    setStemRadio(e.target.value);
  };

  useEffect(() => {
    props
      .getAddLeadMasterList({
        access_token: props.auth?.accessToken?.access_token,
      })
      .then((res) => {
        if (res?.status === 200) {
          setAddLeadMasterData(res?.data?.dtoList);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });

    props
      .getEditLeadDetails({
        access_token: props.auth?.accessToken?.access_token,
        leadId: leadId,
        leadId: leadId,
      })
      .then((res) => {
        if (res?.status === 200) {
          form.setFieldsValue({
            admissionstatus: res?.data?.dto?.admissionStatusVaue,
            courseType: res?.data?.dto?.leadCourseTypeName
              ? {
                  label: res?.data?.dto?.leadCourseTypeNameValue,
                  value: res?.data?.dto?.leadCourseTypeName,
                }
              : "",
            loanType: res?.data?.dto?.leadLoanType
              ? {
                  label: res?.data?.dto?.leadLoanTypeValue,
                  value: res?.data?.dto?.leadLoanType,
                }
              : "",
            monthOfAdmissionIntake: res?.data?.dto?.leadMonthOfAddmissionIntake,
            firstName: res?.data?.dto?.leadFirstName,
            universityText:
              res?.data?.dto?.universityNotInList == true
                ? res?.data?.dto?.otherUniversity
                : null,
            lastName: res?.data?.dto?.leadLastName,
            email: res?.data?.dto?.leadEmail,
            mobile: res?.data?.dto?.leadMobile,
            leadPancardNo: res?.data?.dto?.leadPancardNo,
            leadPassportNo: res?.data?.dto?.leadPassportNo,
            pincode: {
              label: res?.data?.dto?.leadPincode,
              value: res?.data?.dto?.leadPincodeId,
            },
            city: res?.data?.dto?.leadCityName,
            state: res?.data?.dto?.leadStateName,
            admissionstatus: res?.data?.dto?.admissionStatusTypeId,
            stem: res?.data?.dto?.stemCourse,

            country: res?.data?.dto?.countryOfStudy
              ? {
                  label: res?.data?.dto?.countryOfStudy,
                  value: res?.data?.dto?.countryOfStudyId,
                }
              : "",
            partnerBranchPincode: res?.data?.dto?.partnerBranchPincode
              ? {
                  label: res?.data?.dto?.partnerBranchPincode,
                  value: res?.data?.dto?.partnerBranchPincodeId,
                }
              : "",
            amountRequested: res?.data?.dto?.amountRequested || "",

            university:
              res?.data?.dto?.universityNotInList === true
                ? null
                : res?.data?.dto?.universityName
                ? {
                    label: res?.data?.dto?.universityName,
                    value: res?.data?.dto?.universityId,
                  }
                : "",
            institute: res?.data?.dto?.instituteName
              ? {
                  label: res?.data?.dto?.instituteName,
                  value: res?.data?.dto?.instituteId,
                }
              : "",
            instituteText:
              res?.data?.dto?.instituteNotInList == true
                ? res?.data?.dto?.otherInstitute
                : null,
            selectPartner: res?.data?.dto?.partnerFirmName
              ? {
                  label: res?.data?.dto?.partnerFirmName,
                  value: res?.data?.dto?.partnerFirmId,
                }
              : "",
            course:
              res?.data?.dto?.courseNotInList == true
                ? null
                : res?.data?.dto?.courseName
                ? {
                    label: res?.data?.dto?.courseName,
                    value: res?.data?.dto?.courseId,
                  }
                : "",
            courseText:
              res?.data?.dto?.courseNotInList == true
                ? res?.data?.dto?.otherCourse
                : null,
          });
          setPartnerBranchPincodeValue(res?.data?.dto?.partnerBranchPincode);
          setPartnerBranchPincodeId(res?.data?.dto?.partnerBranchPincodeId);
          setCounrtyDataId(res?.data?.dto?.countryOfStudyId);
          setStateName(res?.data?.dto?.leadStateName);
          setStateId(res?.data?.dto?.leadStateId);
          setCityId(res?.data?.dto?.leadCityId);
          setCityName(res?.data?.dto?.leadCityName);
          setValueRadio(res?.data?.dto?.admissionStatusTypeId);
          setShowDrowDown(res?.data?.dto?.universityNotInList);
          setShowSchool(res?.data?.dto?.instituteNotInList);
          setshowCours(res?.data?.dto?.courseNotInList);
          setContactRadio(res?.data?.dto?.contactCenterQualification);
          setDocvalue(res?.data?.dto?.uploadDocuments);
          setUni(
            res?.data?.dto?.universityNotInList === true
              ? null
              : res?.data?.dto?.universityName
              ? {
                  label: res?.data?.dto?.universityName,
                  value: res?.data?.dto?.universityId,
                }
              : ""
          );

          setInst(
            res?.data?.dto?.instituteNotInList == true
              ? null
              : res?.data?.dto?.instituteName
              ? {
                  label: res?.data?.dto?.instituteName,
                  value: res?.data?.dto?.instituteId,
                }
              : ""
          );
          setCour(
            res?.data?.dto?.courseNotInList == true
              ? null
              : res?.data?.dto?.courseName
              ? {
                  label: res?.data?.dto?.courseName,
                  value: res?.data?.dto?.courseId,
                }
              : ""
          );
          const coApplicantsWithIndex = (
            res?.data?.dto?.leadCoApplicantList?.length > 0
              ? res.data.dto.leadCoApplicantList
              : Array.from({ length: 2 }, (_, index) => ({
                  ...initialCoApplicantData,
                  incomeTobeConsideredFlag: index === 0 ? true : false,
                }))
          ).map((coApplicant, index) => ({
            ...coApplicant,
            required: true,
          }));

          setCoApplicants(coApplicantsWithIndex);

          setState({
            universityText:
              res?.data?.dto?.universityNotInList == true
                ? res?.data?.dto?.otherUniversity
                : null,
            instituteText:
              res?.data?.dto?.instituteNotInList == true
                ? res?.data?.dto?.otherInstitute
                : null,
            courseText:
              res?.data?.dto?.courseNotInList == true
                ? res?.data?.dto?.otherCourse
                : null,
          });
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });

    props
      ?.getRelationshipDetails({
        access_token: props.auth?.accessToken?.access_token,
      })
      .then((res) => {
        const temp = res?.data?.dtoList;

        const data = temp.map((el) => {
          return {
            label: el?.descriptionInPennant,
            value: el?.codeInPennant,
          };
        });
        setRelOptions(data);
      });
  }, []);

  const countryData =
    addLeadMasterData?.length > 0
      ? addLeadMasterData.map((el) => {
          return {
            label: el.countryName,
            value: el.countryId,
          };
        })
      : [];
  const [counrtyDataId, setCounrtyDataId] = useState("");

  const handleChangeCountryData = (val) => {
    setState({
      ...state,
      institute: "",
      course: "",
      university: "",
      country: {
        countryId: val.value,
        countryName: val.label,
      },
    });
    setCounrtyDataId(val.value);

    setUni("");
    setInst("");
    setCour("");
    form.setFieldValue("university", "");
    form.setFieldValue("institute", "");
    form.setFieldValue("course", "");
  };

  const handlelistHide = () => {
    setShowDrowDown(!showDrowDown);
    setUni("");
    setInst("");
    setCour("");
    setUni("");
    form.setFieldValue("university", "");
    form.setFieldValue("institute", "");
    form.setFieldValue("course", "");
    form.setFieldValue("instituteText", "");
    form.setFieldValue("courseText", "");
    form.setFieldValue("universityText", "");
    setState({
      ...state,
      university: "",
      institute: "",
      instituteText: "",
      universityText: "",
      courseText: "",
    });
  };
  const handleinstitue = () => {
    setShowSchool(!showSchool);
    setInst("");
    setCour("");
    form.setFieldValue("institute", "");
    form.setFieldValue("course", "");
    form.setFieldValue("instituteText", "");
    form.setFieldValue("courseText", "");
    setState({
      ...state,
      institute: "",
      instituteText: "",
      courseText: "",
    });
  };

  const handlecoures = () => {
    setshowCours(!showCours);
  };

  const loadUniversity = (universityInputValue, callback) => {
    let universityArray = [];
    if (universityInputValue.length > 2) {
      let params = {
        universityName: universityInputValue,
        countryId: counrtyDataId,
      };

      props
        .searchUniversityDetails({
          access_token: props.auth?.accessToken?.access_token,
          params,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.universityId,
                  label: element?.universityName,
                };
                universityArray.push(values);
              });
            callback(universityArray);
          } else {
            callback([]);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadColleges = (collegeInputValue, callback) => {
    let collegeArray = [];

    if (collegeInputValue.length > 1) {
      let params = {
        instituteName: collegeInputValue,

        universityId: state?.university?.value || uni.value,
        countryId:
          state?.country?.countryId === undefined
            ? counrtyDataId
            : state?.country?.countryId,
      };

      props
        .searchCollegeDetails({
          access_token: props.auth?.accessToken?.access_token,
          params,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.instituteId,
                  label: element?.instituteName,
                };
                collegeArray.push(values);
              });
            callback(collegeArray);
          } else {
            callback([]);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadCourses = (courseInputValue, callback) => {
    let courseArray = [];
    if (courseInputValue.length > 2) {
      let params = {
        courseName: courseInputValue,
        instituteId: inst?.value,
      };

      props
        .searchCourseDetail({
          access_token: props.auth?.accessToken?.access_token,
          params,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.courseId,
                  label: element?.courseName,
                };
                courseArray.push(values);
              });
            callback(courseArray);
          } else {
            callback([]);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadPartner = (partnerInputValue, callback) => {
    let partnerArray = [];
    if (partnerInputValue.length > 2) {
      props
        .searchPartnerNameDetail({
          access_token: props.auth?.accessToken?.access_token,
          partnerName: partnerInputValue,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  value: element?.partnerFirmId,
                  label: element?.partnerFirmName,
                };
                partnerArray.push(values);
              });
            callback(partnerArray);
          } else {
            callback([]);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((err) => {
          callback([]);
        });
    }
  };

  const loadPincodes = (inputValue, callback) => {
    if (inputValue.length > 2) {
      props
        .getPincodeList({
          access_token: props.auth?.accessToken?.access_token,
          inputValue,
        })
        .then((res) => {
          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  label: element.pincode,
                  value: element.pincodeId,
                };
                pincodeArray.push(values);
              });
            callback(pincodeArray);
          } else {
          }
        });
    }
  };

  const getBranchLocationMaster = (pincodeId) => {
    props
      .getBranchLocationByPincode({
        access_token: props.auth?.accessToken?.access_token,
        url: "getAll/LocationsUsingPincodeId",
        pincode: pincodeId,
        data: {
          pincodeMaster: {
            pincodeId: pincodeId,
            pincode: inputValue,
            cityId: cityId,
            serviceable: true,
            groupId: 1,
            // area: area,
            active: true,
          },
          cityMaster: {
            cityName: cityName,
            cityId: cityId,
          },
          stateMaster: {
            stateName: stateName,
            stateId: stateId,
          },
        },
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const { cityMaster, stateMaster } = res?.data;

            setCityId(cityMaster?.cityId);
            setStateId(stateMaster?.stateId);
            setStateName(stateMaster?.stateName);

            setCityName(cityMaster?.cityName);
            setFieldsValue({
              city: cityMaster?.cityName,
              state: stateMaster?.stateName,
            });
          } else {
            if (res?.data?.error || res.message) {
              const errorCode = res?.data?.error?.errorCode || res.errorCode;
              const errorMessage = res?.data?.error?.message || res.message;

              if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                handleSessionExpired();
              } else {
                notification.error({
                  description: errorMessage,
                  duration: 5,
                  placement: "top",
                });
              }
            }
          }
        }
      });
  };

  const pincodeInputChange = (value) => {
    setValue(value);
  };
  const pincodeDropChange = (pincodeObj) => {
    getBranchLocationMaster(pincodeObj.value);
  };

  const handleUniversityChange = (val) => {
    setUni({
      label: val.label,
      value: val.value,
    });
    form.setFieldValue("university", {
      value: val.value,
      label: val.label,
    });

    setInst("");
    setCour("");

    form.setFieldValue("institute", "");
    form.setFieldValue("course", "");
    form.setFieldValue("instituteText", "");
    form.setFieldValue("courseText", "");
    form.setFieldValue("universityText", "");
    setState({
      ...state,
      university: {
        value: val.value,
        label: val.label,
      },
      institute: "",
      instituteText: "",
      universityText: "",
      courseText: "",
    });
  };
  const onChangeDoc = (e) => {
    setDocvalue(!docvalue);
  };

  const handleChangeQualification = (e) => {
    setContactRadio(e.target.value);
  };

  const handleInstituteChange = (val) => {
    setState({
      ...state,
      courseText: "",
      course: "",
      institute: {
        value: val.value,
        label: val.label,
      },
    });
    setCour("");

    form.setFieldValue("institute", {
      value: val.value,
      label: val.label,
    });
    form.setFieldValue("courseText", "");
    form.setFieldValue("course", "");
    setInst({
      label: val.label,
      value: val.value,
    });
  };

  const handleCourseChange = (val) => {
    setState({
      ...state,
      course: {
        value: val.value,
        label: val.label,
      },
    });

    form.setFieldValue("course", {
      value: val.value,
      label: val.label,
    });
    setCour({
      label: val.label,
      value: val.value,
    });
  };

  useEffect(() => {
    props
      .getSideBarBranch({
        access_token: props.auth?.accessToken?.access_token,
        partnerFirmId: partnerFirmId,
      })
      .then((res) => {
        if (res?.status === 200) {
          setDataPartnerBranchPincode(res?.data);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  }, [partnerFirmId, drawerOpen]);

  useEffect(() => {
    dispatch(
      getCourseTypeName({
        access_token: props.auth?.accessToken?.access_token,
        url: "ByName",
        name: "COURSE_TYPE_NAME",
      })
    ).then((res) => {
      if (res?.status === 200) {
        setCourseType(
          res?.data?.dtoList?.map((item) => ({
            label: item.code,
            value: item.serialId,
          }))
        );
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
    dispatch(
      getCourseTypeName({
        access_token: props.auth?.accessToken?.access_token,
        url: "ByName",
        name: "LOAN_TYPE",
      })
    ).then((res) => {
      if (res?.status === 200) {
        setLoanType(
          res?.data?.dtoList?.map((item) => ({
            label: item.code,
            value: item.serialId,
          }))
        );
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
  }, []);

  const dataPartnerBranch =
    dataPartnerBranchPincode?.length > 0
      ? dataPartnerBranchPincode.map((el) => {
          return {
            label: el.partnerBranchLocationAddress?.pincode,
            value: el.partnerBranchLocationAddress?.pincodeId,
          };
        })
      : [];

  const handleChangepartnerBranchPincodeData = (val) => {
    setState({
      ...state,
      partnerBranchPincode: {
        id: val.value,
        name: val.label,
        dataPartnerBranch: val.partnerBranchId,
      },
    });
    setPartnerBranchPincodeValue(val?.label);
    setPartnerBranchPincodeId(val.value);
  };

  const handleSubmitLeadDetails = (Data) => {
    const data = {
      partnerLead: true,
      leadPincode: Data?.pincode?.label,
      leadPincodeId: Data?.pincode?.value,
      amountRequested: Data?.amountRequested,
      leadStateId: stateId,
      courseId: Data?.course?.value ?? "",
      courseNotInList: showCours,
      leadStateName: stateName,
      leadCityId: cityId,
      leadCityName: cityName,
      universityId: !showDrowDown ? Data?.university?.value || "" : "",
      universityName: !showDrowDown ? Data?.university?.label || "" : "",
      instituteId: Data?.institute?.value || "",
      instituteNotInList: showSchool,
      otherCourse: showCours ? state?.courseText?.trim() ?? "" : "",
      otherInstitute: showSchool ? state?.instituteText?.trim() ?? "" : "",
      otherUniversity: showDrowDown ? state?.universityText?.trim() ?? "" : "",
      partnerBranchPincode: Data?.partnerBranchPincode?.label,
      partnerBranchPincodeId: Data?.partnerBranchPincode?.value,
      universityNotInList: showDrowDown,
      stemCourse: stemRadio,
      admissionStatusTypeId: valueRadio,
      leadEmail: Data?.email,
      leadFirstName: Data?.firstName?.trim(),
      leadCoApplicantList: coApplicants,
      leadLastName: Data?.lastName?.trim(),
      leadMobile: Data?.mobile?.trim(),
      countryOfStudyId: Data?.country?.value,
      partnerFirmId: props?.auth?.checkLogin?.partnerFirmId,
      leadPancardNo: state?.leadPancardNo,
      leadPassportNo: state?.leadPassportNo,
      // leadStatus: "NEW_LEADS",
      leadSource: "Partner",
      contactCenterQualification: false,
      leadId: leadId,
      uploadDocuments: docvalue,
      leadStatusFlag: true,
      leadCourseTypeName: Data?.courseType?.value,
      leadLoanType: Data?.loanType?.value || null,
      leadMonthOfAddmissionIntake: Data?.monthOfAdmissionIntake || null,
      leadPartnerType: qualificationType,
    };

    setBtnDisable(true);

    props
      .saveAddLeadDetails({
        access_token: props.auth?.accessToken?.access_token,
        values: data,
      })
      .then((res) => {
        setBtnDisable(false);
        if (res && res.status === 200) {
          message.success("Lead Edited Successfully ", 2);
          form.resetFields();
          history("/leadManagementDashboard/leadManagement");

          if (docvalue) {
            history("/leadManagementDashboard/addLeadDoc", {
              state: { leadId },
            });
            return;
          }

          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              //
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const handlenewEooro = () => {
    setValError(true);
  };

  const handleMobileNumberKeyPress = (event) => {
    const { key, target } = event;
    const isValueExceedingLimit = target.value.length >= 10;

    if ((!/^\d$/.test(key) && key !== ".") || isValueExceedingLimit) {
      event.preventDefault();
    }
  };
  const handleChangeRelationData = (value, index) => {
    setCoApplicants((prevCoApplicants) => {
      return prevCoApplicants.map((applicant, i) => ({
        ...applicant,
        relationship: i === index ? value.label : applicant.relationship,
        relationshipId: i === index ? value.value : applicant.relationshipId,
      }));
    });
  };

  const onChangeCoApp = (e, name, index) => {
    // Extract the value from the event object
    const { value } = e.target;

    // Log the value (optional)

    // Update the coApplicants state by mapping over the existing array
    const updatedCoApplicants = coApplicants.map((applicant, i) =>
      // If the current index matches the specified index, update the specified field with the new value
      i === index ? { ...applicant, [name]: value } : applicant
    );

    // Set the state with the updated coApplicants array
    setCoApplicants(updatedCoApplicants);
  };

  const toggleIncomeTobeConsidered = (index) => {
    setCoApplicants((prevCoApplicants) => {
      return prevCoApplicants.map((applicant, i) => ({
        ...applicant,
        incomeTobeConsideredFlag:
          i == 0
            ? applicant.incomeTobeConsideredFlag
            : i == index
            ? !applicant.incomeTobeConsideredFlag
            : applicant.incomeTobeConsideredFlag,
      }));
    });
  };

  const addCoApplicant = () => {
    const newCoApplicant = {
      type: "newCoApplicant",
      ...initialCoApplicantData,
      incomeTobeConsideredFlag: false,
      required: true,
    };
    setCoApplicants([...coApplicants, newCoApplicant]);
  };

  const deleteCoApp = (index) => {
    // Use filter to create a new array without the coapplicant with the specified index
    const updatedCoApplicants = coApplicants.filter((_, i) => i !== index);

    // Update the state with the new array
    setCoApplicants(updatedCoApplicants);
  };

  const handleDelete = () => {
    setdisablecoapp(true);

    props
      ?.deleteCoApp({
        access_token: props.auth?.accessToken?.access_token,
        applicantId: deleteId,
      })
      .then((res) => {
        form.setFieldValue(reletion, {
          label: "",
          value: "",
        });
        if (res && res.status === 200) {
          form.setFieldValue(reletion, {
            label: "",
            value: "",
          });

          setDeteteModal(false);
          setdisablecoapp(false);
          props
            .getEditLeadDetails({
              access_token: props.auth?.accessToken?.access_token,
              leadId: leadId,
            })
            .then((res) => {
              if (res?.status === 200) {
                form.setFieldsValue({
                  firstName: res?.data?.dto?.leadFirstName,
                  universityText:
                    res?.data?.dto?.universityNotInList == true
                      ? res?.data?.dto?.otherUniversity
                      : null,
                  lastName: res?.data?.dto?.leadLastName,
                  email: res?.data?.dto?.leadEmail,
                  mobile: res?.data?.dto?.leadMobile,
                  pincode: {
                    label: res?.data?.dto?.leadPincode,
                    value: res?.data?.dto?.leadPincodeId,
                  },
                  city: res?.data?.dto?.leadCityName,
                  state: res?.data?.dto?.leadStateName,
                  admissionstatus: res?.data?.dto?.admissionStatusTypeId,
                  stem: res?.data?.dto?.stemCourse,

                  country: res?.data?.dto?.countryOfStudy
                    ? {
                        label: res?.data?.dto?.countryOfStudy,
                        value: res?.data?.dto?.countryOfStudyId,
                      }
                    : "",
                  partnerBranchPincode: res?.data?.dto?.partnerBranchPincode
                    ? {
                        label: res?.data?.dto?.partnerBranchPincode,
                        value: res?.data?.dto?.partnerBranchPincodeId,
                      }
                    : "",
                  amountRequested: res?.data?.dto?.amountRequested || "",

                  university:
                    res?.data?.dto?.universityNotInList === true
                      ? null
                      : res?.data?.dto?.universityName
                      ? {
                          label: res?.data?.dto?.universityName,
                          value: res?.data?.dto?.universityId,
                        }
                      : "",
                  institute: res?.data?.dto?.instituteName
                    ? {
                        label: res?.data?.dto?.instituteName,
                        value: res?.data?.dto?.instituteId,
                      }
                    : "",
                  instituteText:
                    res?.data?.dto?.instituteNotInList == true
                      ? res?.data?.dto?.otherInstitute
                      : null,
                  selectPartner: res?.data?.dto?.partnerFirmName
                    ? {
                        label: res?.data?.dto?.partnerFirmName,
                        value: res?.data?.dto?.partnerFirmId,
                      }
                    : "",
                  course:
                    res?.data?.dto?.courseNotInList == true
                      ? null
                      : res?.data?.dto?.courseName
                      ? {
                          label: res?.data?.dto?.courseName,
                          value: res?.data?.dto?.courseId,
                        }
                      : "",
                  courseText:
                    res?.data?.dto?.courseNotInList == true
                      ? res?.data?.dto?.otherCourse
                      : null,
                });
                setPartnerBranchPincodeValue(
                  res?.data?.dto?.partnerBranchPincode
                );
                setPartnerBranchPincodeId(
                  res?.data?.dto?.partnerBranchPincodeId
                );
                setCounrtyDataId(res?.data?.dto?.countryOfStudyId);
                setStateName(res?.data?.dto?.leadStateName);
                setStateId(res?.data?.dto?.leadStateId);
                setCityId(res?.data?.dto?.leadCityId);
                setCityName(res?.data?.dto?.leadCityName);
                setValueRadio(res?.data?.dto?.admissionStatusTypeId);
                setShowDrowDown(res?.data?.dto?.universityNotInList);
                setShowSchool(res?.data?.dto?.instituteNotInList);
                setshowCours(res?.data?.dto?.courseNotInList);
                setContactRadio(res?.data?.dto?.contactCenterQualification);
                setDocvalue(res?.data?.dto?.uploadDocuments);
                setUni(
                  res?.data?.dto?.universityNotInList === true
                    ? null
                    : res?.data?.dto?.universityName
                    ? {
                        label: res?.data?.dto?.universityName,
                        value: res?.data?.dto?.universityId,
                      }
                    : ""
                );

                setInst(
                  res?.data?.dto?.instituteNotInList == true
                    ? null
                    : res?.data?.dto?.instituteName
                    ? {
                        label: res?.data?.dto?.instituteName,
                        value: res?.data?.dto?.instituteId,
                      }
                    : ""
                );
                setCour(
                  res?.data?.dto?.courseNotInList == true
                    ? null
                    : res?.data?.dto?.courseName
                    ? {
                        label: res?.data?.dto?.courseName,
                        value: res?.data?.dto?.courseId,
                      }
                    : ""
                );
                const coApplicantsWithIndex = (
                  res?.data?.dto?.leadCoApplicantList?.length > 0
                    ? res.data.dto.leadCoApplicantList
                    : Array.from({ length: 2 }, (_, index) => ({
                        ...initialCoApplicantData,
                        incomeTobeConsideredFlag: index === 0 ? true : false,
                      }))
                ).map((coApplicant, index) => ({
                  ...coApplicant,
                  required: true,
                }));

                setCoApplicants(coApplicantsWithIndex);

                setState({
                  universityText:
                    res?.data?.dto?.universityNotInList == true
                      ? res?.data?.dto?.otherUniversity
                      : null,
                  instituteText:
                    res?.data?.dto?.instituteNotInList == true
                      ? res?.data?.dto?.otherInstitute
                      : null,
                  courseText:
                    res?.data?.dto?.courseNotInList == true
                      ? res?.data?.dto?.otherCourse
                      : null,
                });
              }
              if (res?.data?.error || res.message) {
                const errorCode = res?.data?.error?.errorCode || res.errorCode;
                const errorMessage = res?.data?.error?.message || res.message;

                if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                  handleSessionExpired();
                } else {
                  notification.error({
                    description: errorMessage,
                    duration: 5,
                    placement: "top",
                  });
                }
              }
            });
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              //
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  return (
    <div>
      {LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}
      <Modal
        open={deleteModal}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="logout"
          className="change-password"
          form={form}
        >
          <Row className="mt-4">
            <Col lg={12} xs={12} md={12} sm={12}>
              <p>Are you sure you want to delete this record ?</p>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md={12} className="d-flex justify-content-end mt-4">
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={() => {
                  setDeteteModal(false);
                }}
              >
                CANCEL
              </Button>
              <Button
                disabled={disablecoapp}
                className=""
                type="primary"
                onClick={handleDelete}
              >
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Form
        name="addLead"
        autoComplete="off"
        form={form}
        onFinish={handleSubmitLeadDetails}
        className="edit-lead"
      >
        <div className="form-inner-content new-se">
          <div className="content-sc-drawer">
            <div className="header-sec-drawer">
              <UISectionHeading drawerHeading="Edit Lead" />
            </div>

            <div className="form-sec-drawer">
              <Row>
                <Col lg={12} xs={12} md={12} sm={12} className="inner-sec-text">
                  <Col md={5} className="">
                    <FormItem
                      name="firstName"
                      label="First Name"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter First Name",
                        },
                        {
                          pattern: new RegExp("^[a-zA-Z ]+$"),
                          message: "please enter a valid first name",
                        },
                      ]}
                    >
                      <TextInput
                        disabled={true}
                        type="text"
                        name="firstName"
                        onInput={(e) => {
                          if (e.target.value.trim() == "") {
                            e.target.value = e.target.value.trim();
                          }

                          if (e.target.value.trim() !== "") {
                            e.target.value = new RegExp("^[a-zA-Z ]+$").test(
                              e.target.value
                            )
                              ? e.target.value?.trimStart()
                              : e.target.value
                                  ?.trimStart()
                                  ?.substring(0, e.target.value.length - 1);
                          }
                        }}
                        value={state.firstName}
                        onChange={onChangeTextHandler}
                        maxLength={75}
                      />
                    </FormItem>
                  </Col>
                  <Col md={5} className="">
                    <FormItem
                      name="lastName"
                      label="Last Name"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Last Name",
                        },
                        {
                          pattern: new RegExp("^[a-zA-Z ]+$"),
                          message: "please enter a valid last name",
                        },
                      ]}
                    >
                      <TextInput
                        disabled={true}
                        name="lastName"
                        onInput={(e) => {
                          if (e.target.value.trim() == "") {
                            e.target.value = e.target.value.trim();
                          }

                          if (e.target.value.trim() !== "") {
                            e.target.value = new RegExp("^[a-zA-Z]+$").test(
                              e.target.value
                            )
                              ? e.target.value.trimStart()
                              : e.target.value
                                  .trimStart()
                                  ?.substring(0, e.target.value.length - 1);
                          }
                        }}
                        value={state.lastName}
                        onChange={onChangeTextHandler}
                        type="text"
                        maxLength={75}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text first-sec-mon"
                >
                  <Col md={7} className="">
                    <FormItem
                      name="email"
                      label="Email Address"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Enter Email Address",
                        },
                        {
                          pattern:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Please Enter a valid Email!",
                        },
                      ]}
                    >
                      <TextInput
                        maxLength={255}
                        onInput={(e) => {
                          if (e.target.value.trim() == "") {
                            e.target.value = e.target.value.trim();
                          }

                          if (e.target.value.trim() !== "") {
                            e.target.value = e.target.value.trimStart();
                          }
                        }}
                        type="email"
                        name="email"
                        value={state.email}
                        onChange={onChangeTextHandler}
                      />
                    </FormItem>
                  </Col>
                  <Col md={5} className="">
                    <FormItem
                      name="mobile"
                      label="Mobile"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Mobile Number",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || /^[0-9]{10}$/.test(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Invalid mobile number");
                          },
                        }),
                      ]}
                    >
                      <TextInput
                        name="mobile"
                        disabled={true}
                        value={state.mobile}
                        onInput={(e) => {
                          if (e.target.value.trim() == "") {
                            e.target.value = e.target.value.trim();
                          }

                          if (e.target.value.trim() !== "") {
                            e.target.value = e.target.value.trimStart();
                          }
                        }}
                        onChange={onChangeTextHandler}
                        type="tel"
                        maxLength={10}
                        onKeyPress={handleMobileNumberKeyPress}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text list-sec-row"
                >
                  <Col md={4} className="pincode-sec">
                    <FormItem
                      name="pincode"
                      label="Pin code"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Pin code",
                        },
                      ]}
                    >
                      <AsyncSelect
                        className="pinNew"
                        // cacheOptions
                        maxLength="7"
                        value={inputValue}
                        loadOptions={loadPincodes}
                        onInputChange={(e) => pincodeInputChange(e)}
                        onChange={pincodeDropChange}
                      />
                    </FormItem>
                  </Col>
                  <Col md={4} className="">
                    <FormItem
                      name="city"
                      label="City"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter City",
                        },
                      ]}
                    >
                      <TextInput
                        value={state.city}
                        onChange={onChangeTextHandler}
                        type="text"
                        disabled={true}
                      />
                    </FormItem>
                  </Col>
                  <Col md={4} className="">
                    <FormItem
                      name="state"
                      label="State"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Enter State",
                        },
                      ]}
                    >
                      <TextInput
                        value={state.state}
                        onChange={onChangeTextHandler}
                        type="text"
                        disabled={true}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col md={5} className="">
                  <FormItem
                    name="leadPancardNo"
                    label="Partner Company Pan"
                    colon={false}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.resolve(); // Allow empty input
                          }

                          const panRegex = /^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]{1}$/;

                          if (panRegex.test(value)) {
                            return Promise.resolve(); // Valid PAN
                          }

                          if (value.length >= 4 && value[3] !== "P") {
                            return Promise.reject(
                              "The 4th letter should be 'P'"
                            );
                          }

                          return Promise.reject("Invalid PAN number");
                        },
                      }),
                    ]}
                  >
                    <TextInput
                      name="leadPancardNo"
                      value={state.leadPancardNo}
                      onInput={(e) => {
                        if (e.target.value.trim() == "") {
                          e.target.value = e.target.value.trim();
                        }

                        if (e.target.value.trim() !== "") {
                          e.target.value = e.target.value.trimStart();
                        }
                      }}
                      onChange={onChangeTextHandler}
                      type="text"
                      maxLength={10}
                      onKeyPress={handleMobileNumberKeyPress}
                      disabled={true}
                    />
                  </FormItem>
                </Col>

                <Col md={5} className="">
                  <FormItem
                    name="leadPassportNo"
                    label="Passport"
                    colon={false}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || /^[A-Z][0-9]{7}$/.test(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject("Invalid Passport Number");
                        },
                      }),
                    ]}
                  >
                    <TextInput
                      name="leadPassportNo"
                      value={state.leadPassportNo}
                      onInput={(e) => {
                        if (e.target.value.trim() == "") {
                          e.target.value = e.target.value.trim();
                        }

                        if (e.target.value.trim() !== "") {
                          e.target.value = e.target.value.trimStart();
                        }
                      }}
                      onChange={onChangeTextHandler}
                      type="text"
                      maxLength={10}
                      onKeyPress={handleMobileNumberKeyPress}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-textt"
                >
                  <Col md={4} className="coApprelation">
                    <FormItem
                      name="courseType"
                      label="Course Type"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Select Course Type",
                        },
                      ]}
                    >
                      <UiDropDown
                        className="newPin"
                        placeholder="Select"
                        data={courseType}
                        onChange={(value) => {
                          onChangeTextHandler({
                            target: { name: "courseType", value },
                          });
                        }}
                        value={state.courseType}
                      />
                    </FormItem>
                  </Col>
                  <Col md={4} className="coApprelation">
                    <FormItem name="loanType" label="Loan Type" colon={false}>
                      <UiDropDown
                        className="newPin"
                        placeholder="Select"
                        data={loanType}
                        onChange={(value) => {
                          onChangeTextHandler({
                            target: { name: "loanType", value },
                          });
                        }}
                        value={state.loanType}
                      />
                    </FormItem>
                  </Col>
                  <Col md={4} className="coApprelation">
                    <FormItem
                      name="monthOfAdmissionIntake"
                      label="Month of Admission Intake"
                      colon={false}
                    >
                      <TextInput
                        name="monthOfAdmissionIntake"
                        value={state.monthOfAdmissionIntake}
                        onChange={onChangeTextHandler}
                        type="text"
                        maxLength={20}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              <br></br>
              <h3 className="main-sec-inter">Admission Info</h3>

              <Row>
                <Col lg={12} xs={12} md={12} sm={12} className="inner-sec-text">
                  <Col md={10} className="cheched-grop-sec">
                    <FormItem
                      name="admissionstatus"
                      label="Admission Status"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Select Admission Status",
                        },
                      ]}
                    >
                      <Radio.Group
                        defaultValue={291}
                        onChange={onChangeAdmission}
                        value={valueRadio}
                      >
                        <Radio value={291}>Undecided</Radio>
                        <Radio value={292}>Applied</Radio>
                        <Radio value={293}>Confirmed</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text sec-check-list"
                >
                  <Col md={6} className="">
                    <FormItem
                      name="country"
                      label="Country"
                      colon={false}
                      rules={[
                        {
                          required:
                            valueRadio === 292 || valueRadio === 293
                              ? true
                              : false,
                          message: "Please Select Country",
                        },
                      ]}
                    >
                      <UiDropDown
                        data={countryData}
                        onChange={handleChangeCountryData}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>

              {valueRadio === 292 ? (
                <>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showDrowDown ? (
                          <>
                            <FormItem
                              name="university"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !uni ? "error" : "success"
                              }
                              help={
                                valError && !uni
                                  ? "Please Select University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                value={uni}
                                placeholder={"Type 3 letters"}
                                loadOptions={loadUniversity}
                                onChange={handleUniversityChange}
                                // cacheOptions
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="universityText"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.universityText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.universityText
                                  ? "Please Enter University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="universityText"
                                value={state.universityText}
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                onChange={onChangeTextHandler}
                                type="text"
                                maxLength={200}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                      <Col md={6} className="unver-sec">
                        {!showSchool ? (
                          <>
                            <FormItem
                              name="institute"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !inst ? "error" : "success"
                              }
                              help={
                                valError && !inst
                                  ? "Please Select School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                value={inst}
                                isClearable={true}
                                placeholder={"Type 3 letters"}
                                loadOptions={loadColleges}
                                onChange={handleInstituteChange}
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="instituteText"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.instituteText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.instituteText
                                  ? "Please Enter School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="instituteText"
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.instituteText}
                                onChange={onChangeTextHandler}
                                maxLength={200}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showCours ? (
                          <>
                            <FormItem
                              name="course"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !cour ? "error" : "success"
                              }
                              help={
                                valError && !cour ? "Please Select Course" : ""
                              }
                            >
                              {" "}
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                placeholder={"Type 3 letters"}
                                loadOptions={loadCourses}
                                onChange={handleCourseChange}
                                isClearable={true}
                                value={cour}
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="courseText"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.courseText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.courseText
                                  ? "Please Enter Course"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="courseText"
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.courseText}
                                onChange={onChangeTextHandler}
                                maxLength={200}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text"
                    >
                      <Col md={10} className="cheched-grop-sec">
                        {showCours && (
                          <FormItem
                            name="stem"
                            label="Stem/Programme Type"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: " Please Strem/Programme Type",
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={handleStemChanges}
                              value={stemRadio}
                            >
                              <Radio value={true}>Stem</Radio>
                              <Radio value={false}>Non Stem</Radio>
                            </Radio.Group>
                          </FormItem>
                        )}
                      </Col>
                    </Col>
                  </Row>
                </>
              ) : null}

              {valueRadio === 293 ? (
                <>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showDrowDown ? (
                          <>
                            <FormItem
                              name="university"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !uni ? "error" : "success"
                              }
                              help={
                                valError && !uni
                                  ? "Please Select University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                value={uni}
                                placeholder={"Type 3 letters"}
                                loadOptions={loadUniversity}
                                onChange={handleUniversityChange}
                                // cacheOptions
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="universityText"
                              label="University Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.universityText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.universityText
                                  ? "Please Enter University"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlelistHide}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="universityText"
                                value={state.universityText}
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                onChange={onChangeTextHandler}
                                type="text"
                                maxLength={255}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                      <Col md={6} className="unver-sec">
                        {!showSchool ? (
                          <>
                            <FormItem
                              name="institute"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !inst ? "error" : "success"
                              }
                              help={
                                valError && !inst
                                  ? "Please Select School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                value={inst}
                                isClearable={true}
                                placeholder={"Type 3 letters"}
                                loadOptions={loadColleges}
                                onChange={handleInstituteChange}
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="instituteText"
                              label="School / Institue Name"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.instituteText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.instituteText
                                  ? "Please Enter School/Institue Name"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handleinstitue}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="instituteText"
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.instituteText}
                                onChange={onChangeTextHandler}
                                maxLength={255}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text university-sec"
                    >
                      <Col md={6} className="unver-sec">
                        {!showCours ? (
                          <>
                            <FormItem
                              name="course"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !cour ? "error" : "success"
                              }
                              help={
                                valError && !cour ? "Please Select Course" : ""
                              }
                            >
                              {" "}
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Not In List
                              </div>
                              <AsyncSelect
                                placeholder={"Type 3 letters"}
                                loadOptions={loadCourses}
                                onChange={handleCourseChange}
                                isClearable={true}
                                value={cour}
                                // cacheOptions
                              />
                            </FormItem>
                          </>
                        ) : (
                          <>
                            <FormItem
                              name="courseText"
                              label="Course"
                              colon={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              validateStatus={
                                valError && !state?.courseText
                                  ? "error"
                                  : "success"
                              }
                              help={
                                valError && !state?.courseText
                                  ? "Please Enter Course"
                                  : ""
                              }
                            >
                              <div
                                className="list-sec-option-btn"
                                onClick={handlecoures}
                              >
                                Select From List
                              </div>
                              <TextInput
                                name="courseText"
                                type="text"
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                value={state.courseText}
                                onChange={onChangeTextHandler}
                                maxLength={255}
                              />
                            </FormItem>
                          </>
                        )}
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="inner-sec-text"
                    >
                      <Col md={10} className="cheched-grop-sec">
                        {showCours && (
                          <FormItem
                            name="stem"
                            label="Stem/Programme Type"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Please Strem/Programme Type",
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={handleStemChanges}
                              value={stemRadio}
                            >
                              <Radio value={true}>Stem</Radio>
                              <Radio value={false}>Non Stem</Radio>
                            </Radio.Group>
                          </FormItem>
                        )}
                      </Col>
                    </Col>
                  </Row>
                </>
              ) : null}

              <br></br>

              <Row>
                <Col lg={12} xs={12} md={12} sm={12} className="inner-sec-text">
                  <Col md={6} className="cheched-grop-sec">
                    <FormItem
                      name="amountRequested"
                      label="Required Amount"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Please Amount Requested",
                        },
                      ]}
                    >
                      {/* <TextInput
                          name="amountRequested"
                          type="number"
                          value={state.amountRequested ?? 0}
                          onChange={onChangeTextHandler}
                        /> */}
                      <InputNumber
                        className="amtinpt"
                        maxLength={255}
                        formatter={(value) => {
                          const numFormat = new Intl.NumberFormat("en-IN");
                          if (value === "") {
                            return value;
                          }
                          const numericValue = Number(
                            value.replace(/[^\d.]/g, "")
                          );
                          if (isNaN(numericValue)) {
                            return "";
                          }
                          return numFormat.format(numericValue);
                        }}
                        parser={(value) => value.replace(/[^\d.]/g, "")}
                        // value={state.amountRequested}
                        onChange={onChangeTextHandler}
                        onKeyDown={(e) => {
                          if (
                            // Allow numeric keys and navigation keys
                            !e.key.match(/^\d$/) &&
                            e.key !== "Tab" &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </FormItem>
                  </Col>
                  <Col md={6} className="cheched-grop-sec">
                    <FormItem
                      name="partnerBranchPincode"
                      label="Partner Branch Pincode"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Strem/Programme Type",
                        },
                      ]}
                    >
                      <UiDropDown
                        className="newPin"
                        data={dataPartnerBranch}
                        onChange={handleChangepartnerBranchPincodeData}
                      />
                    </FormItem>
                  </Col>
                </Col>
              </Row>
              {/* <Row>
                  <Col md={6}>
                    <FormItem
                      name="contactCenterQualification"
                      label="Contact Center Qualification"
                      colon={false}
                      rules={[
                        {
                          required: false,
                          message: "Please Select Contact Center Qualification",
                        },
                      ]}
                    >
                      <Radio.Group
                        onChange={handleChangeQualification}
                        value={contactRadio}
                        defaultValue={false}
                      >
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                </Row> */}
              {/* <h3 className="main-sec-inter">CoApplicant Info</h3>
              <br></br>
              <br></br> */}

              {/* <>
                {coApplicants.map((applicant, index) => {
                  form.setFieldValue(
                    `CoAppfirstName${index}`,
                    applicant.firstName
                  );

                  form.setFieldValue(
                    `CoApplastName${index}`,
                    applicant.lastName
                  );

                  form.setFieldValue(
                    `CoAppMobileNo${index}`,
                    applicant.mobileNo
                  );
                  if (applicant?.relationship && applicant?.relationshipId) {
                    form.setFieldValue(`CoAppRelation${index}`, {
                      label: applicant?.relationship,
                      value: applicant?.relationshipId,
                    });
                  } else {
                    form.setFieldValue(`CoAppRelation${index}`, "");
                  }
                  form.setFieldValue(
                    `CoAppEmail${index}`,
                    applicant.emailAddress
                  );

                  return (
                    <>
                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={3}>
                            <h5>{`CoApplicant ${index + 1}`}</h5>
                          </Col>
                          <Col md={4} style={{ display: "flex" }}>
                            <FormItem
                              name="considerIncome"
                              label=""
                              colon={false}
                              rules={[
                                {
                                  required: false,
                                  message: "Please Please Strem/Programme Type",
                                },
                              ]}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Checkbox
                                  className="addleadcheckbox"
                                  checked={applicant.incomeTobeConsideredFlag}
                                  onChange={() =>
                                    toggleIncomeTobeConsidered(index)
                                  }
                                  disabled={index == 0}
                                />
                                <h6>Income to be considered</h6>
                              </div>
                            </FormItem>
                          </Col>
                          <Col md={5}></Col>
                          <Col md={2}>
                            {applicant.type == "newCoApplicant" && (
                              <CloseOutlined
                                onClick={() => {
                                  deleteCoApp(index);
                                }}
                              />
                            )}
                            {applicant.isCoapplicantDeletable && (
                              <CloseOutlined
                                onClick={() => {
                                  setDeteteModal(true);
                                  setDeleteID(applicant?.applicantId);
                                  setRelation(`CoAppRelation${index}`);
                                }}
                              />
                            )}
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={5} className="">
                            <FormItem
                              name={`CoAppfirstName${index}`}
                              label="First Name"
                              colon={false}
                              rules={[
                                {
                                  required: applicant?.required,
                                  message: "Please Enter First Name",
                                },
                                {
                                  pattern: new RegExp("^[a-zA-Z ]+$"),
                                  message: "please enter a valid first name",
                                },
                              ]}
                            >
                              <TextInput
                                name={`CoAppfirstName${index}`}
                                type="text"
                                onInput={(e) => {
                                  // Remove leading whitespaces
                                  const trimmedValue =
                                    e.target.value.trimStart();
                                  e.target.value = trimmedValue;

                                  if (trimmedValue !== "") {
                                    // Check if the input contains only alphabetical characters
                                    e.target.value = new RegExp(
                                      "^[a-zA-Z ]+$"
                                    ).test(trimmedValue)
                                      ? trimmedValue
                                      : trimmedValue.substring(
                                          0,
                                          trimmedValue.length - 1
                                        );
                                  }
                                }}
                                value={applicant.firstName}
                                onChange={(e) =>
                                  onChangeCoApp(e, "firstName", index)
                                }
                                maxLength={75}
                              />
                            </FormItem>
                          </Col>
                          <Col md={5} className="">
                            <FormItem
                              name={`CoApplastName${index}`}
                              label="Last Name"
                              colon={false}
                              rules={[
                                {
                                  required: applicant?.required,
                                  message: "Please Enter Last Name",
                                },
                                {
                                  pattern: new RegExp("^[a-zA-Z ]+$"),
                                  message: "please enter a valid last name",
                                },
                              ]}
                            >
                              <TextInput
                                name={`CoApplastName${index}`}
                                onInput={(e) => {
                                  // Remove leading whitespaces
                                  const trimmedValue =
                                    e.target.value.trimStart();
                                  e.target.value = trimmedValue;

                                  if (trimmedValue !== "") {
                                    // Check if the input contains only alphabetical characters
                                    e.target.value = new RegExp(
                                      "^[a-zA-Z ]+$"
                                    ).test(trimmedValue)
                                      ? trimmedValue
                                      : trimmedValue.substring(
                                          0,
                                          trimmedValue.length - 1
                                        );
                                  }
                                }}
                                value={applicant.lastName}
                                onChange={(e) =>
                                  onChangeCoApp(e, "lastName", index)
                                }
                                type="text"
                                maxLength={75}
                              />
                            </FormItem>
                          </Col>
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={7} className="">
                            <FormItem
                              name={`CoAppEmail${index}`}
                              label="Email Address"
                              colon={false}
                              rules={[
                                {
                                  required: false,
                                  message: "Please Enter Email Address",
                                },
                                {
                                  pattern:
                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                  message: "Please Enter a valid Email!",
                                },
                              ]}
                            >
                              <TextInput
                                name={`emailAddress${index}`}
                                value={applicant.emailAddress}
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                }}
                                onChange={(e) =>
                                  onChangeCoApp(e, "emailAddress", index)
                                }
                                type="text"
                                maxLength={75}
                              />
                            </FormItem>
                          </Col>

                          <Col md={5} className="">
                            <FormItem
                              name={`CoAppMobileNo${index}`}
                              label="Mobile No"
                              colon={false}
                              rules={[
                                {
                                  required: applicant?.required,
                                  message: "Please Enter Mobile Number",
                                },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (
                                      !value ||
                                      /^[6-9][0-9]{9}$/.test(value)
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      "Invalid mobile number"
                                    );
                                  },
                                }),
                              ]}
                            >
                              <TextInput
                                name={`mobileNo${index}`}
                                type="text"
                                maxLength={10}
                                onInput={(e) => {
                                  if (e.target.value.trim() == "") {
                                    e.target.value = e.target.value.trim();
                                  }

                                  if (e.target.value.trim() !== "") {
                                    e.target.value = new RegExp(
                                      "^[0-9-+]*$"
                                    ).test(e.target.value)
                                      ? e.target.value?.trimStart()
                                      : e.target.value
                                          ?.trimStart()
                                          ?.substring(
                                            0,
                                            e.target.value.length - 1
                                          );
                                  }
                                }}
                                value={applicant.mobileNo}
                                onKeyPress={handleMobileNumberKeyPress}
                                onChange={(e) =>
                                  onChangeCoApp(e, "mobileNo", index)
                                }
                              />
                            </FormItem>
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-sec-text first-sec-mon"
                        >
                          <Col md={7} className="coApprelation">
                            <FormItem
                              name={`CoAppRelation${index}`}
                              label="Relationship With Student"
                              colon={false}
                              rules={[
                                {
                                  required: applicant?.required,
                                  message: "Please  select one option",
                                },
                              ]}
                            >
                              <UiDropDown
                                data={reloptions}
                                onChange={(value) =>
                                  handleChangeRelationData(value, index)
                                }
                              />
                            </FormItem>
                          </Col>
                        </Col>
                      </Row>
                      <br></br>
                      <br></br>
                    </>
                  );
                })}

                
              </> */}
              <br></br>
              <Row>
                <Col
                  lg={12}
                  xs={12}
                  md={12}
                  sm={12}
                  className="inner-sec-text first-sec-mon"
                >
                  <Col md={5}></Col>

                  <Col md={3}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {/* <Checkbox
                        checked={docvalue}
                        onClick={onChangeDoc}
                        className="addleadcheckbox"
                      />
                      <h6>Upload documents</h6> */}
                    </div>
                  </Col>
                  <Col
                    className="AddCoAppBtn"
                    style={{ marginRight: "30px" }}
                    md={3}
                  >
                    {/* <UiButton
                      disabled={coApplicants.length == 5}
                      type="button"
                      title="Add coapplicant"
                      onClick={addCoApplicant}
                    /> */}
                  </Col>
                  <Col md={3}>
                    <UiButton
                      disabled={btnDisable}
                      type="submit"
                      title={"SAVE & UPDATE LEAD"}
                      onClick={handlenewEooro}
                    />
                  </Col>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getAddLeadMasterList: (data) => dispatch(getAddLeadMasterList(data)),
    searchUniversityDetails: (user) => dispatch(searchUniversityDetails(user)),
    searchCollegeDetails: (user) => dispatch(searchCollegeDetails(user)),
    searchCourseDetail: (user) => dispatch(searchCourseDetail(user)),
    getPincodeList: (data) => dispatch(getPincodeOnSearch(data)),
    getBranchLocationByArea: (data) => dispatch(getBranchLocationByArea(data)),
    getBranchLocationByPincode: (data) =>
      dispatch(getBranchLocationByPincode(data)),
    getSideBarBranch: (data) => dispatch(getSideBarBranch(data)),
    searchPartnerNameDetail: (data) => dispatch(searchPartnerNameDetail(data)),
    getRelationshipDetails: (data) => dispatch(getRelationshipDetails(data)),
    saveAddLeadDetails: (data) => dispatch(saveAddLeadDetails(data)),
    getEditLeadDetails: (data) => dispatch(getEditLeadDetails(data)),
    deleteCoApp: (data) => dispatch(deleteCoApp(data)),
  };
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    state: state && state.auth,
    lead: state.viewLeadReducer,
    access_token: state && state.auth && state.auth.idToken,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditLead);
